import incidentsRedux from '../../views/overview/redux/slice'
import historyIncidentsRedux from '../../views/history/redux/slice'

export default {
    incidentsRedux,
    historyIncidentsRedux
}